import { countries } from 'countries-list';

const useCountries = () => {
  return Object.entries(countries).map(([code, name]) => ({
    code,
    name: name.name
  }));
};

export default useCountries;
